// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"234":"16767298","353":"fb964c7a"}[chunkId] + ".js";
};